module.exports = __webpack_public_path__ + "static/assets/207348664b5e3869daae47edafc65b26.svg";